import _extends from "@babel/runtime-corejs3/helpers/extends";
import { useInstance, createRef } from 'intact-vue';
import { useDraggable } from '../../hooks/useDraggable';
import tinycolor from 'tinycolor2';
import { isNumber } from 'intact-shared';
window.tinycolor = tinycolor;
export function usePointer(hsv, format) {
  var instance = useInstance();
  var areaRef = createRef();
  var _useDraggable = useDraggable({
      onStart: function onStart(e) {
        handleChange(e);
      },
      onMove: function onMove(e) {
        handleChange(e);
      }
    }),
    start = _useDraggable.start;
  // @reference: https://github.com/casesandberg/react-color/blob/master/src/helpers/saturation.js
  function handleChange(e) {
    var _areaRef$value$getBou = areaRef.value.getBoundingClientRect(),
      width = _areaRef$value$getBou.width,
      height = _areaRef$value$getBou.height,
      _left = _areaRef$value$getBou.left,
      _top = _areaRef$value$getBou.top;
    var x = isNumber(e.pageX) ? e.pageX : e.touches[0].pageX;
    var y = isNumber(e.pageY) ? e.pageY : e.touches[0].pageY;
    var left = x - _left - window.pageXOffset;
    var top = y - _top - window.pageYOffset;
    left = Math.max(Math.min(width, left), 0);
    top = Math.max(Math.min(height, top), 0);
    var saturation = left / width;
    var bright = -top / height + 1;
    hsv.set(_extends({}, hsv.value, {
      s: saturation,
      v: bright
    }));
    // const value = tinycolor(hsv.value!).toString(format.value as 'rgb');
    // // console.log()
    // // const tinyValue = tinycolor(value);
    // // console.log(hsv, value, tinycolor(hsv).toHsv(), getFormat(), tinyValue.toHsv());
    // instance.set({value});
  }
  return {
    start: start,
    areaRef: areaRef
  };
}